export const TAB_SUFFIX = "tab";
export const TAB_PANEL_SUFFIX = "tab-panel";
